import { Level2, Level3 } from '../StyledOl';

const PurchasePriceAndPaymentTerms = () => (
  <li>
    PURCHASE PRICE AND PAYMENT TERMS
    <Level2>
      <li>
        All payments are made in Singapore Dollars unless agreed otherwise with LINK . All prices in
        the Contractor&rsquo;s quotations are not subject to adjustment unless otherwise agreed by
        LINK in writing. The Contractor, shall at its own costs, obtain and maintain such licence
        and authorisations including export licences, permits and other governmental authorisations
        or certification which are required to enable the Contractor to fulfill its obligations
        under this Purchase Order and LINK shall not be required to pay any additional sum above the
        prices shown in the Contractor&rsquo;s quotations for the same. LINK shall pay to the
        Contractor a sum equal to the Singapore Goods and Services Tax chargeable on the supply of
        the Goods to LINK. Contractor agrees that payment by an Affiliate of LINK on behalf of LINK
        shall be accepted as good and valid consideration for the Goods sold or Services rendered
        herein.
      </li>
      <li>
        Unless agreed otherwise by LINK in writing, thirty (30) days after LINK &rsquo;s receipt of
        the Contractor&rsquo;s bills, LINK will make payment to the Contractor of the full value of
        the Goods so delivered or the Services so performed provided that no payment shall be
        considered as evidence of the quality of the Goods and/or Services to which such payment
        relates nor shall it relieve the Contractor from its obligations under this Purchase Order.
        In the event LINK reasonably disputes any portion of a payment of this Purchase Order to the
        Contractor, the amount not in dispute shall be promptly paid as described above, LINK shall
        within fifteen (15) days of its receipt of any disputed invoice, provide the Contractor with
        written notice substantiating LINK&rsquo;s dispute.
      </li>
      <li>
        Without prejudice to LINK&rsquo;s other rights under this Purchase Order, if the Contractor
        owes LINK any payment or debt (the &ldquo;&nbsp;
        <strong>Outstanding Amount</strong>&rdquo;) under this Purchase Order, LINK shall have the
        right to:
        <Level3>
          <li>
            withhold any moneys payable by LINK to the Contractor pursuant to this Purchase Order
            until the Outstanding Amount is satisfied; or
          </li>
          <li>
            deduct the Outstanding Amount from any moneys payable by LINK to the Contractor pursuant
            to this Purchase Order .
          </li>
        </Level3>
      </li>
      <li>
        Unless agreed otherwise in the Purchase Order, all prices are fixed and include delivery and
        all other ancillary charges, including without limitation, cost of transport, insurance, and
        packing, taxes levies and any fees attributed by the Contractor&rsquo;s supplier or
        distributor, as a result of the supply of the Goods and/or Services unless otherwise agreed
        by the Parties in writing in advance.
      </li>
    </Level2>
  </li>
);

export default PurchasePriceAndPaymentTerms;
